export default "__VITE_ASSET__d0e8dabe__"